import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';

import { DatevTenantService } from './DatevTenantService.entity';

export class DatevTenant<T extends EMode = EMode.entity> {
  /** Alias: client_Number */
  clientNumber?: number;
  /** Alias: consultant_Number */
  consultantNumber?: number;
  /** Alias: iD */
  id?: string;
  /** Alias: name */
  name?: string;
  /** Alias: services */
  services?: DatevTenantService<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<DatevTenant> = {
  clientNumber: {
    alias: 'client_Number',
  },
  consultantNumber: {
    alias: 'consultant_Number',
  },
  id: {
    alias: 'iD',
  },
  name: {
    alias: 'name',
  },
  services: {
    alias: 'services',
    entity: Entities.datevTenantService,
  },
  __typename: {
    alias: '__typename',
  },
};

export const datevTenantEntityDefinition: EntitiyDefinition<DatevTenant> = {
  local: {},
  remote: {
    queryName: 'getDatevTenants',
    fragmentName: 'DatevTenant',
    withPaginationWrapper: false,
  },
  fieldDefinitions: fields,
};
